export const STORAGE_KEYS = {
  withoutFooterCards: 'withoutFooterCards',
  successfulPurchaseModalInfo: 'successfulPurchaseModalInfo',
  successfulPurchaseModalTitle: 'successfulPurchaseModalTitle',
  isFormDisplayed: 'isFormDisplayed',
  orderId: 'orderId',
  orderDetails: 'orderDetails',
  contact_phone: 'contact_phone',
}
